import isInjuredStatus from './isInjuredStatus';
import getInjuryStatusColor from './getInjuryStatusColor';

export { isInjuredStatus, getInjuryStatusColor };

const BUCKET_LABELS = {
	probable: 'Probable',
	questionable: 'Questionable',
	doubtful: 'Doubtful',
	out: 'Out',
	ir: 'IR',
	pup: 'PUP',
	inactive: 'Inactive',
	suspended: 'Suspended',
	nfi: 'NFI',
	other: 'Other'
};

export function normalizeStatusBucket(status) {
	if (!status || !isInjuredStatus(status)) return null;

	const normalized = status.toLowerCase();

	if (normalized.includes('probable')) return 'probable';
	if (normalized.includes('questionable')) return 'questionable';
	if (normalized.includes('doubtful')) return 'doubtful';
	if (normalized.includes('out')) return 'out';
	if (normalized.includes('ir')) return 'ir';
	if (normalized.includes('physically unable') || normalized.includes('pup')) {
		return 'pup';
	}
	if (normalized.includes('inactive')) return 'inactive';
	if (normalized.includes('suspended')) return 'suspended';
	if (normalized.includes('nfi')) return 'nfi';

	return 'other';
}

export function getSeverityScore(status) {
	const bucket = normalizeStatusBucket(status);
	if (!bucket) return 0;

	const scores = {
		out: 100,
		ir: 95,
		pup: 90,
		inactive: 88,
		suspended: 85,
		nfi: 82,
		doubtful: 75,
		questionable: 55,
		probable: 35,
		other: 50
	};

	return scores[bucket] || 50;
}

export function parseExpectedReturnWeek(status) {
	if (!status) return null;

	const match = String(status).match(/expected\s+return:\s*week\s*(\d+)/i);
	return match ? parseInt(match[1], 10) : null;
}

export function statusBucketLabel(bucket) {
	return BUCKET_LABELS[bucket] || bucket;
}

/** Display order for status breakdown (severity-first, then game-day labels). */
export const INJURY_STATUS_DISPLAY_ORDER = [
	'Out',
	'Questionable',
	'Probable',
	'Doubtful',
	'IR',
	'PUP',
	'Inactive',
	'Suspended',
	'NFI',
	'Other'
];

export function sortStatusCountEntries(entries) {
	return [...entries].sort((a, b) => {
		const indexA = INJURY_STATUS_DISPLAY_ORDER.indexOf(a[0]);
		const indexB = INJURY_STATUS_DISPLAY_ORDER.indexOf(b[0]);
		return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
	});
}
